import React from "react";
import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { ViewInvoiceCTA, ViewOrderDetailsCTA, ViewOrdersCTA } from "./ctas";
import { InvoiceDetailsIA } from "./instantAnswersComponents/orders/InvoiceDetailsIA";
import { isAusOrEurBrand } from "./utils/brandBasedIn";
export var invoiceDetails = function invoiceDetails(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    additionalRequiredData: [ShippingContextDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INVOICE_DETAILS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return INVOICE_DETAILS_DESCRIPTION(context);
    }
  };
};
var INVOICE_DETAILS_TITLE = function INVOICE_DETAILS_TITLE(strictLocalize) {
  if (isAusOrEurBrand()) {
    return strictLocalize({
      id: "ZyCrsT",
      defaultMessage: [{
        "type": 0,
        "value": "Waar vind ik een bestelfactuur?"
      }]
    });
  }
  return strictLocalize({
    id: "NnCsrY",
    defaultMessage: [{
      "type": 0,
      "value": "Facturen bestellen"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (isAusOrEurBrand() && brandOrderToken) {
    return ViewInvoiceCTA(brandOrderToken, strictLocalize);
  }
  if (brandOrderToken) {
    return ViewOrderDetailsCTA(brandOrderToken, strictLocalize);
  }
  return ViewOrdersCTA(strictLocalize);
};
var INVOICE_DETAILS_DESCRIPTION = function INVOICE_DETAILS_DESCRIPTION(context) {
  var _context$brandOrder2, _context$brandOrder2$;
  return /*#__PURE__*/React.createElement(InvoiceDetailsIA, {
    isAusOrEurBrand: isAusOrEurBrand(),
    brandOrderToken: (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token
  });
};